import { styled } from '@mui/system';

const CardsSection = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
});

const CardsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '50px',
  justifyContent: 'center',
  flexWrap: 'wrap',
  flexDirection: 'row',
  margin: '30px auto',
  width: '100%',
  [theme.breakpoints.up(740)]: {
    // width: '95%',
    maxWidth: '650px',
  },
  [theme.breakpoints.up(1100)]: {
    // width: '95%',
    maxWidth: '1000px',
  },
  [theme.breakpoints.up(1450)]: {
    // width: '80%',
    maxWidth: '1350px',
  },
  [theme.breakpoints.down(740)]: {
    margin: '17px 0 40px',
    gap: '0',
    justifyContent: 'left',
    '&>a': {
      width: '50%',
    },
  },
}));

const NoteCardsSection = ({ children }) => {
  return (
    <CardsSection>
      <CardsContainer>{children}</CardsContainer>
    </CardsSection>
  );
};

export default NoteCardsSection;
